<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div class="jk-grid-cols-4">
    <app-jkbtnedit  maintable="STKMA" item="W01" valueExpr="MA001" displayExpr="MA002"
 label="商品代號" #TM002Com  id="TM002"  [(value)]="item.TM002" [required]="true"  placeholder="商品代號"  [readonly]="isBrowse"  (valueChange)="srv.TM002Change(item)"     >
    </app-jkbtnedit>
    <app-jkedit  label="商品名稱" #TM003Com  id="TM003"  [(value)]="item.TM003" [required]="true"  placeholder="商品名稱"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkcheckboxYN  label="啟用" #TM023Com  id="TM023"  [(valueYN)]="item.TM023"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkedit  label="狀態" #TM006Com  id="TM006"  [(value)]="item.TM006" placeholder="狀態"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkdatefield  label="設定日期" #TM007Com  id="TM007"  [(value)]="item.TM007" placeholder="設定日期"  [readonly]="isBrowse"
            >
    </app-jkdatefield>
    <app-jktext  label="設定時間" [value]="item.TM025"     >
    </app-jktext>
    <app-jkedit  label="觀盤重點" #TM012Com  id="TM012"  [(value)]="item.TM012" placeholder="觀盤重點"  [readonly]="isBrowse"     >
    </app-jkedit>
    <button mat-flat-button [disabled]="isBrowse" color="primary" (click)="srv.doClearPrice()">清除所有通知價</button>
    <app-jknumberedit  label="智慧單買價" #TM118Com  id="TM118"  [(value)]="item.TM118" placeholder="智慧單買價"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="智慧單賣價" #TM119Com  id="TM119"  [(value)]="item.TM119" placeholder="智慧單賣價"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="突破通知價" #TM110Com  id="TM110"  [(value)]="item.TM110" placeholder="突破通知價"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="跌破通知價" #TM111Com  id="TM111"  [(value)]="item.TM111" placeholder="跌破通知價"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="停損價" #TM112Com  id="TM112"  [(value)]="item.TM112" placeholder="停損價"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="第一停利價" #TM113Com  id="TM113"  [(value)]="item.TM113" placeholder="第一停利價"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="第二停利價" #TM114Com  id="TM114"  [(value)]="item.TM114" placeholder="第二停利價"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="支撐1" #TM115Com  id="TM115"  [(value)]="item.TM115" placeholder="支撐1"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="支撐2" #TM116Com  id="TM116"  [(value)]="item.TM116" placeholder="支撐2"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="壓力" #TM117Com  id="TM117"  [(value)]="item.TM117" placeholder="壓力"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkbtnedit  maintable="STKME" item="W01" valueExpr="ME001" displayExpr="ME002"
 label="群組代號" #TM014Com  id="TM014"  [(value)]="item.TM014" placeholder="群組代號,空白表示全市場 "  [readonly]="isBrowse"  (valueChange)="srv.TM014Change(item)"     >
    </app-jkbtnedit>
    <app-jkdatefield  label="收盤價時間" #TM107Com  id="TM107"  [(date)]="item.TM107" placeholder="收盤價時間"  [readonly]="isBrowse"
            >
    </app-jkdatefield>
    <app-jknumberedit  label="排序" #TM026Com  id="TM026"  [(value)]="item.TM026" placeholder="排序"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkcombobox  label="通知方法" #TM027Com  id="TM027"  [(value)]="item.TM027" [items]="srv.StkTm027List"  [readonly]="isBrowse"     >
    </app-jkcombobox>
    <app-jkcombobox  label="通知頻率" #TM028Com  id="TM028"  [(value)]="item.TM028" [items]="srv.StkTm028List"  [readonly]="isBrowse"     >
    </app-jkcombobox>
    <app-jkdatefield  label="上次通知日期" #TM029Com  id="TM029"  [(value)]="item.TM029" placeholder="上次通知日期"  [readonly]="isBrowse"
            >
    </app-jkdatefield>
    <app-jktext  label="上次通知時間" [value]="item.TM030"     >
    </app-jktext>
    <app-jknumberedit  label="買進張數" #TM041Com  id="TM041"  [(value)]="item.TM041" placeholder="買進張數"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="最大張數" #TM042Com  id="TM042"  [(value)]="item.TM042" placeholder="最大張數"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="昨收" #TM043Com  id="TM043"  [(value)]="item.TM043" placeholder="昨收"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="預估損益" #TM044Com  id="TM044"  [(value)]="item.TM044" placeholder="預估損益"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="開盤價" #TM100Com  id="TM100"  [(value)]="item.TM100" placeholder="開盤價"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkdatefield  label="開盤時間" #TM101Com  id="TM101"  [(date)]="item.TM101" placeholder="開盤時間"  [readonly]="isBrowse"
            >
    </app-jkdatefield>
    <app-jknumberedit  label="最高價" #TM102Com  id="TM102"  [(value)]="item.TM102" placeholder="最高價"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkdatefield  label="最高價時間" #TM103Com  id="TM103"  [(date)]="item.TM103" placeholder="最高價時間"  [readonly]="isBrowse"
            >
    </app-jkdatefield>
    <app-jkdatefield  label="更新日期時間" #TM005Com  id="TM005"  [(date)]="item.TM005" placeholder="更新日期時間"  [readonly]="isBrowse"
            >
    </app-jkdatefield>
    <app-jknumberedit  label="最低價" #TM104Com  id="TM104"  [(value)]="item.TM104" placeholder="最低價"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkdatefield  label="最低價時間" #TM105Com  id="TM105"  [(date)]="item.TM105" placeholder="最低價時間"  [readonly]="isBrowse"
            >
    </app-jkdatefield>
    <app-jknumberedit  label="總成交量" #TM106Com  id="TM106"  [(value)]="item.TM106" placeholder="總成交量"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="收盤價" #TM108Com  id="TM108"  [(value)]="item.TM108" placeholder="收盤價"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="上次收盤價" #TM109Com  id="TM109"  [(value)]="item.TM109" placeholder="上次收盤價"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="庫存數量" #TM008Com  id="TM008"  [(value)]="item.TM008" placeholder="庫存數量"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="最大數量" #TM009Com  id="TM009"  [(value)]="item.TM009" placeholder="最大數量"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="平均成本" #TM010Com  id="TM010"  [(value)]="item.TM010" placeholder="平均成本"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkbtnedit  maintable="CMSMV" item="W01" valueExpr="MV001" displayExpr="MV002"
 label="使用者代號" #TM011Com  id="TM011"  [(value)]="item.TM011" placeholder="使用者代號"  [readonly]="isBrowse"  (valueChange)="srv.TM011Change(item)"     >
    </app-jkbtnedit>
    <app-jkedit  label="帳號代號" #TM013Com  id="TM013"  [(value)]="item.TM013" placeholder="帳號代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jknumberedit  label="庫存量" #TM120Com  id="TM120"  [(value)]="item.TM120" placeholder="庫存量"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkedit  label="市場代號" #TM046Com  id="TM046"  [(value)]="item.TM046" placeholder="市場代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktext  label="單號" [value]="item.TM001"     >
    </app-jktext>
    <app-jktext  label="保留" [value]="item.TM024"     >
    </app-jktext>
    <app-jkcheckboxYN  label="結案碼" #TM004Com  id="TM004"  [(valueYN)]="item.TM004"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>

    </div>
  </div>
</div>
